import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import { Link } from "@inertiajs/react";
import { Trans, useTranslation } from 'react-i18next';
import FrontText from "../FrontText";
import { Icon } from "@iconify/react";

const FrontWarehousesToRent = () => {
    const { t, i18n } = useTranslation();

    const warehouses = t('warehouses_to_rent.warehouses', {returnObjects: true});
    return (
        <Container>
            <Row>
                <Column>
                    <FrontText textSize='38/43-m-24/27' className="font-domine font-bold text-center mb-10">
                        <h3>{t('warehouses_to_rent.heading')}</h3>
                    </FrontText>
                </Column>
                <Column>
                    <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-rows-5 gap-y-3 md:gap-y-5 gap-x-5">
                        {warehouses.map((elem, index) => (
                            <Link href={resolveLocaleRoute(elem.link, null, i18n.resolvedLanguage)} title={elem.title} key={index} className="flex items-center gap-2 shrink-0 text-standard-black hover:text-yellow transition-all ease-in-out duration-200">
                                <Icon icon='ic:round-navigate-next' className="shrink-0" width={24} height={24}/>
                                <FrontText textSize='16/20' className="font-medium">
                                    {elem.title}
                                </FrontText>
                            </Link>
                        ))}
                    </div>
                </Column>
            </Row>
        </Container>
    )
}

export default FrontWarehousesToRent;